<template>
  <div style="padding:2px;">
    <div style=" width:1141px;margin:auto">      
      <div style="font-size:18px;font-weight: 700;text-align: left; height:50px;line-height: 70px; border-bottom: 2px solid #ccc;"> 产品中心</div>
      <el-card class="box-card" shadow="never" style="margin-top:10px;" >
        <div slot="header" style="text-align: left;">
          <span><i class="el-icon-s-shop"></i> 最新上架</span>
          <span style="float:right;font-size:16px;color:red;">共计345个产品</span>
        </div>
        <div style="display:flex;flex-direction: row;flex-wrap: wrap;justify-content: space-between;">
          <div>
            <el-card :body-style="{ padding: '0px' }">
              <img style="width:250px;height:250px;" src="../../assets/Product/634777bfaae75.jpg">
              <div style="padding: 14px;">
                <span>家电用钢</span>
              </div>
            </el-card>
          </div>
          <div>
            <el-card :body-style="{ padding: '0px' }">
              <img style="width:250px;height:250px;" src="../../assets/Product/63477cde64ded.jpg">
              <div style="padding: 14px;">
                <span>汽车用钢</span>
              </div>
            </el-card>
          </div>
          <div>
            <el-card :body-style="{ padding: '0px' }">
              <img style="width:250px;height:250px;" src="../../assets/Product/63477d0168a1a.jpg">
              <div style="padding: 14px;">
                <span>汽车用钢</span>
              </div>
            </el-card>
          </div>
          <div>
            <el-card :body-style="{ padding: '0px' }">
              <img style="width:250px;height:250px;" src="../../assets/Product/6347a8512b844.jpg">
              <div style="padding: 14px;">
                <span>建筑用钢</span>
              </div>
            </el-card>
          </div>          
        </div>
      </el-card>
      <el-card class="box-card" shadow="never" style="margin-top:10px;" >
      <div slot="header" style="text-align: left;">
        <span ><i class="el-icon-truck"></i> 热销产品</span>        
        <span style="float:right;font-size:16px;color:red;">共计45个产品</span>
      </div>
      <div style="display:flex;flex-direction: row;flex-wrap: wrap;justify-content: space-between;">
          <div>
            <el-card :body-style="{ padding: '0px' }">
              <img style="width:250px;height:250px;" src="../../assets/Product/63477cde64ded.jpg">
              <div style="padding: 14px;">
                <span>汽车用钢</span>
              </div>
            </el-card>
          </div>
          <div>
            <el-card :body-style="{ padding: '0px' }">
              <img style="width:250px;height:250px;" src="../../assets/Product/63477d0168a1a.jpg">
              <div style="padding: 14px;">
                <span>汽车用钢</span>
              </div>
            </el-card>
          </div>
          <div>
            <el-card :body-style="{ padding: '0px' }">
              <img style="width:250px;height:250px;" src="../../assets/Product/6347a8512b844.jpg">
              <div style="padding: 14px;">
                <span>建筑用钢</span>
              </div>
            </el-card>
          </div>       
          <div>
            <el-card :body-style="{ padding: '0px' }">
              <img style="width:250px;height:250px;" src="../../assets/Product/634777bfaae75.jpg">
              <div style="padding: 14px;">
                <span>家电用钢</span>
              </div>
            </el-card>
          </div>   
      </div>
      </el-card>
      <el-card class="box-card" shadow="never" style="margin-top:10px;" >
      <div slot="header" style="text-align: left;">
        <span ><i class="el-icon-present"></i> 特价商品</span>        
        <span style="float:right;font-size:16px;color:red;">共计8个产品</span>
      </div>
      <div style="display:flex;flex-direction: row;flex-wrap: wrap;justify-content: space-between;">
          <div>
            <el-card :body-style="{ padding: '0px' }">
              <img style="width:250px;height:250px;" src="../../assets/Product/63477d0168a1a.jpg">
              <div style="padding: 14px;">
                <span>汽车用钢</span>
              </div>
            </el-card>
          </div>
          <div>
            <el-card :body-style="{ padding: '0px' }">
              <img style="width:250px;height:250px;" src="../../assets/Product/6347a8512b844.jpg">
              <div style="padding: 14px;">
                <span>建筑用钢</span>
              </div>
            </el-card>
          </div>    
          <div>
            <el-card :body-style="{ padding: '0px' }">
              <img style="width:250px;height:250px;" src="../../assets/Product/634777bfaae75.jpg">
              <div style="padding: 14px;">
                <span>家电用钢</span>
              </div>
            </el-card>
          </div>
          <div>
            <el-card :body-style="{ padding: '0px' }">
              <img style="width:250px;height:250px;" src="../../assets/Product/63477cde64ded.jpg">
              <div style="padding: 14px;">
                <span>汽车用钢</span>
              </div>
            </el-card>
          </div>       
      </div>
      </el-card>
    </div>
    
    <div style="width:100%;margin-top: 10px; background-color: #efefef;text-align: center; height: 50px;line-height: 50px;border-top: 1px solid #ccc; margin-bottom: 2px;">
    2022 重庆市离离科技有限公司 备案 渝ICP备2020011628号-1
  </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      form:{
        region:'',
        hzfs:'',
        hzyx:''
      }

    };
  },
  methods:{
    onSubmit(){

    }
  }
};
</script>
  
  <style lang="less" scoped>

</style>